const listItemWrapper = {
  update: () => {}
};

export default listItemWrapper;
